import { ComponentEuiCallout, ComponentEuiText } from 'Component'


const ComponentNavFormCalloutUnavailable = () => {
    return <ComponentEuiCallout iconType={'alert'} color={'danger'} title={'Action Unavailable'}>{
        <ComponentEuiText><p>This action does not seem to exist</p></ComponentEuiText>
    }</ComponentEuiCallout>
}

export default ComponentNavFormCalloutUnavailable